


































import Vue from "vue";
import { ElementColors } from "@/common/theme/ElementColors";
import { PPOrderStatus } from "@/picking-portal/enums/PPOrderStatus";
import { PPClickAndCollectStatus } from "@/picking-portal/enums/PPClickAndCollectStatus";

export default Vue.extend({
  name: "PPCollectOrderDialog",
  props: {
    dialog: {
      type: Boolean,
      required: true,
    },
    transactionId: {
      type: String,
      required: true,
    },
    orderStatus: {
      type: String,
      required: true,
      default: PPOrderStatus.SUBMITTED,
    },
    clickAndCollectStatus: {
      type: String,
      required: true,
      default: PPClickAndCollectStatus.SUBMITTED,
    },
    restrictedAge: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      Colors: ElementColors,
    };
  },
  computed: {
    isPicked(): boolean {
      return this.clickAndCollectStatus === PPClickAndCollectStatus.PICKED;
    },
    isSubmitted(): boolean {
      return this.clickAndCollectStatus === PPClickAndCollectStatus.SUBMITTED;
    },
    isCollected(): boolean {
      return this.clickAndCollectStatus === PPClickAndCollectStatus.COLLECTED;
    },
    isCancelled(): boolean {
      return this.orderStatus === PPOrderStatus.CANCELLED;
    },
  },
  methods: {
    onClose(): void {
      this.$emit("close");
    },
  },
});
